module.exports = __webpack_public_path__ + "static/img/news-2.58ad09e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/article/news-2.jpg
// module id = kxZk
// module chunks = 5